import {CustomMenu, CustomMenuItem} from '@common/menus/custom-menu';
import {MenuPositions} from '../../menu-positions';
import React, {
  ComponentPropsWithoutRef,
  forwardRef,
  useRef,
  useState,
} from 'react';
import {MenuItemConfig} from '@common/core/settings/settings';
import clsx from 'clsx';
import {useDroppable} from '@common/ui/interactions/dnd/use-droppable';
import {FileEntry} from '@common/uploads/file-entry';
import {FolderTree} from './folder-tree';
import {useDeleteEntries} from '../../files/queries/use-delete-entries';
import {useActiveWorkspaceId} from '@common/workspace/active-workspace-id-context';
import {useIsMobileMediaQuery} from '@common/utils/hooks/is-mobile-media-query';
import { Link } from 'react-router-dom';
export function SidebarMenu() {
  const {workspaceId} = useActiveWorkspaceId();
  const isMobile = useIsMobileMediaQuery();
  return (
    <div className="text-muted  pr-1 ml-3">
      {/* <FolderTree /> */}
      
      <CustomMenu
        menu={MenuPositions.DriveSidebar}
        orientation="vertical"
        gap="gap-0"
      >
       
        {item => {
          if (item.action === '/drive/trash') {
            return <TrashMenuItem key={item.id} item={item} />;
          }
          return <MenuItem key={item.id} item={item} />;
        }}
      </CustomMenu>
    </div>
  );
}

interface MenuItemProps extends ComponentPropsWithoutRef<'a'> {
  item: MenuItemConfig;
  className?: string;
}

const obj = {id: 'h5p54n', type: 'route', order: 4, label: 'Store', action: '/drive/trash'}
export const MenuItem = forwardRef<HTMLAnchorElement, MenuItemProps>(
  ({item, className, ...domProps}, ref) => {
    let actionArray = item.action.split('/');
    actionArray.reverse();
    const baseUrl = window.location.href; 
    let baseUrlArray = baseUrl.split('/');
    baseUrlArray.reverse();
    let isActives = false;
    if(actionArray[0]===baseUrlArray[0])
    {
      isActives = true;
    }
    console.log('isActive',isActives,actionArray[0],baseUrlArray[0]);
    return (
      <CustomMenuItem
        className={({isActive}) =>
          clsx(
            className,
            'h-40 w-full my-4 px-22 rounded-menu font-bt',
            isActives
              ? 'text-primary font-bold bg-primary/selected cursor-default border-l-4 bg-white'
              : 'hover:bg-hover'
          )
        }
        item={item}
        ref={ref}
        {...domProps}
      />
    );
  }
);

interface TrashMenuItemProps {
  item: MenuItemConfig;
}
function TrashMenuItem({item}: TrashMenuItemProps) {
  const deleteEntries = useDeleteEntries();
  const [isDragOver, setIsDragOver] = useState(false);
  const ref = useRef<HTMLAnchorElement>(null);

  const {droppableProps} = useDroppable({
    id: 'trash',
    types: ['fileEntry'],
    ref,
    onDragEnter: () => {
      setIsDragOver(true);
    },
    onDragLeave: () => {
      setIsDragOver(false);
    },
    onDrop: draggable => {
      const entryIds = (draggable.getData() as FileEntry[]).map(e => e.id);
      deleteEntries.mutate({entryIds, deleteForever: false});
    },
  });
  
  return (
    <MenuItem
      className={clsx(isDragOver && 'bg-primary/selected')}
      ref={ref}
      {...droppableProps}
      item={item}
    />
  );
}
